import { render, staticRenderFns } from "./WMonthPicker.vue?vue&type=template&id=3224dc6c&"
import script from "./WMonthPicker.vue?vue&type=script&lang=js&"
export * from "./WMonthPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports